import React from 'react'
import { type StripeElements, type Stripe, type StripeElementsOptions } from '@stripe/stripe-js'
import { Elements, type ExpressCheckoutElementProps } from '@stripe/react-stripe-js'

import { AblefyStripeExpressPaymentElement } from 'shop/components/ablefy-stripe-express-element/AblefyStripeExpressPaymentElement'

interface PaymentElementExtendedProps extends ExpressCheckoutElementProps {
  setStripeElements: (stripeElements: StripeElements) => void
  setStripeClient: (stripeClient: Stripe) => void
}

interface Props {
  options: StripeElementsOptions
  stripePromise: Promise<Stripe>
  elementProps: PaymentElementExtendedProps
  dataTestId: string
}

export const AblefyStripeExpressElementProvider = ({ stripePromise, options, elementProps, dataTestId }: Props) => (
  <div data-testid={dataTestId}>
    <Elements stripe={stripePromise} options={options}>
      <AblefyStripeExpressPaymentElement {...elementProps} />
    </Elements>
  </div>
)
